var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Object.entries(_vm.groupedSlots)),function([date, slots]){return _c('div',{key:date,staticClass:"calendar-day"},[_c('CalendarDay',{attrs:{"slots":slots,"date":date,"mode":_vm.mode}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }